import type { LucideIcon } from 'lucide-react'
import '../SkillMeterInfoModal.css'

/**
 * One tier row: glyph, name, range. Split out of `SkillMeterInfoModal` so the
 * rules screen's intuition demo renders the same badge the modal does instead of a lookalike.
 *
 * Generic over the glyph rather than over `SkillTier`, because the demo leads with the
 * *calibrating* state — which is not a tier and carries the neutral glyph.
 */
export default function SkillTierRow({
  icon: Icon,
  name,
  range,
  color,
  isCurrent = false,
}: {
  icon: LucideIcon
  name: string
  /** Right-hand caption under the name — the tier's percentage band. Omitted for calibrating,
   *  which has no band to name yet. */
  range?: string
  /** The tier's on-surface text colour. See the note in `skillTiers.ts`: these rows are neutral,
   *  so the icon takes the "-text" grade, never the fill tint or the on-fill ink. */
  color?: string
  isCurrent?: boolean
}) {
  return (
    <div
      className={`skill-meter-modal__tier-row ${
        isCurrent ? 'skill-meter-modal__tier-row--current' : ''
      }`}
    >
      <Icon
        className="skill-meter-modal__tier-icon"
        style={color ? { color } : undefined}
        aria-hidden="true"
      />
      <div className="skill-meter-modal__tier-text">
        <p className="skill-meter-modal__tier-name">{name}</p>
        {range && <p className="skill-meter-modal__tier-range">{range}</p>}
      </div>
      {isCurrent && <span className="skill-meter-modal__tier-you">You</span>}
    </div>
  )
}
